import React, { useRef } from "react";

import Map, {
  FullscreenControl,
  GeolocateControl,
  NavigationControl,
  Popup,
} from "react-map-gl";

import "maplibre-gl/dist/maplibre-gl.css";
import "./map.css";

import maplibregl from "maplibre-gl";
import GeocoderControl from "./geocoder/GeocoderControl";
import LayersComponent from "./LayersComponent";
import { useRecoilState, useRecoilValue } from "recoil";
import { visibleLayerDefsIDsWithPopupSelector } from "./layerAtoms";
import { popupAtom } from "./popupAtom";
import { layerDefs } from "./layerDefs";

const OS_KEY = "vmRzM4mAA1Ag0hkjGh1fhA2hNLEM6PYP";

export default function OpdcMap() {
  const mapRef = useRef();
  const [popup, setPopup] = useRecoilState(popupAtom);
  const layersWithPopup = useRecoilValue(visibleLayerDefsIDsWithPopupSelector);

  const layerIDs = Object.keys(layerDefs);

  const handleMapClick = (e) => {
    if (!mapRef?.current || !mapRef.current.loaded()) {
      return;
    }
    setPopup(null);
    if (layersWithPopup.length) {
      const features = mapRef.current.queryRenderedFeatures(e.point, {
        layers: layersWithPopup,
      });

      if (features.length) {
        // need to think of a way to do this with a selector family, but seems difficult to change the paramaters dynamically
        const popupAttributes =
          layerDefs[features[0]?.layer.id].popupAttributes;

        const text = popupAttributes
          .map((attribute) => features[0].properties[attribute])
          .join(": ");
        setPopup({
          text: text,
          coords: e.lngLat,
          layerId: features[0]?.layer.id,
        });
      } else {
        setPopup(null);
      }
    }
  };

  const handleMapHover = (e) => {
    if (!mapRef?.current || !mapRef.current.loaded()) {
      return;
    }

    if (layersWithPopup.length) {
      const features = mapRef.current.queryRenderedFeatures(e.point, {
        layers: layersWithPopup,
      });

      if (features.length) {
        mapRef.current.getCanvas().style.cursor = "pointer";
        return;
      }
    }
    mapRef.current.getCanvas().style.cursor = "";
  };

  const handleResize = () => {
    if (mapRef?.current) {
      setTimeout(() => {
        mapRef.current.resize();
      }, 200);
    }
  };
  window.addEventListener("resize", handleResize);

  return (
    <Map
      id="map"
      initialViewState={{
        longitude: -0.257,
        latitude: 51.53192,
        zoom: 12.06,
        width: "100%",
        height: "100%",
        maxBounds: [
          [-0.9520147334466, 50.1004060804908],
          [2.03512883092415, 52.119059856816],
        ],
        minZoom: 9.2,
        transformRequest: (url) => {
          if (!url.toLowerCase().includes("api.os")) return { url: url };
          if (!/[?&]key=/.test(url)) url += "?key=" + OS_KEY;
          return {
            url: url + "&srs=3857",
          };
        },
      }}
      ref={mapRef}
      mapStyle={"./os_light_vts.json"}
      styleDiffing
      mapLib={maplibregl}
      style={{ width: "100%" }}
      hash={true}
      onClick={handleMapClick}
      onMouseMove={handleMapHover}
    >
      <LayersComponent layersIDs={layerIDs} />
      <GeocoderControl position="top-left" />
      <FullscreenControl position="top-left" />
      <GeolocateControl position="top-left" />
      <NavigationControl position="top-left" />
      {popup && popup.text && popup.coords && (
        <Popup
          style={{ color: "black", fontSize: "14px" }}
          longitude={popup.coords.lng}
          latitude={popup.coords.lat}
        >
          {popup.text}
        </Popup>
      )}
    </Map>
  );
}
